import React from 'react';

const Stepper = ( { stepNumber, setStepNumber } ) => {
    return (
        <div>
             <div className="mx-4 p-4">
                    <div className="flex items-center">


                        <div onClick={() => setStepNumber(1)} className={`flex items-center relative ${stepNumber == 1 ? 'text-indigo-700' : 'text-gray-700'} `} >
                            <div className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${stepNumber == 1 ? 'border-indigo-700' : 'border-gray-300'}`} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-bookmark ">
                                    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                                </svg>
                            </div>
                            <div className="absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase text-teal-600">Basic</div>
                        </div>




                        <div className="flex-auto border-t-2 transition duration-500 ease-in-out border-gray-300" />

                        <div onClick={() => setStepNumber(2)} className={`flex items-center relative ${stepNumber == 2 ? 'text-indigo-700' : 'text-gray-700'} `} >
                            <div className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${stepNumber == 2 ? 'border-indigo-700' : 'border-gray-300'}`} >

                                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-mail ">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                    <polyline points="22,6 12,13 2,6" />
                                </svg>

                            </div>
                            <div className="absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase text-gray-500">Images</div>
                        </div>




                        <div className="flex-auto border-t-2 transition duration-500 ease-in-out border-gray-300" />


                        <div onClick={() => setStepNumber(3)} className={`flex items-center relative ${stepNumber == 3 ? 'text-indigo-700' : 'text-gray-700'} `} >
                            <div className={`rounded-full flex justify-center items-center transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${stepNumber == 3 ? 'border-indigo-700' : 'border-gray-300'}`} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-clock"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                            </div>
                            <div className="absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase text-teal-600">Timing</div>
                        </div>



                        <div className="flex-auto border-t-2 transition duration-500 ease-in-out border-gray-300" />
                        <div onClick={() => setStepNumber(4)} className={`flex items-center relative ${stepNumber == 4 ? 'text-indigo-700' : 'text-gray-700'} `} >
                            <div className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${stepNumber == 4 ? 'border-indigo-700' : 'border-gray-300'}`} >

                                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-database ">
                                    <ellipse cx={12} cy={5} rx={9} ry={3} />
                                    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
                                    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
                                </svg>
                            </div>
                            <div className="absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase text-gray-500">Confirm</div>
                        </div>


                    </div>
                </div>
        </div>
    );
}

export default Stepper;
